var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0h18a1 1 0 011 1v16a1 1 0 01-1 1h-18a1 1 0 01-1-1V1a1 1 0 011-1zm17 4.238l-7.928 7.1L2.5 4.216V16h16V4.238zM3.011 2l7.55 6.662L18.002 2H3.011z"
  })));
}
export default SvgMail;